import React, { Component } from 'react';
import propTypes from 'prop-types';
import loadable from '@loadable/component';

import Notifications from 'app/Notifications/container';
import {
  VISITED_APP,
  VISITED_CANVAS,
  VISITED_COMPONENT,
  VISITED_CONTRACT,
  VISITED_FOLDER,
  VISITED_LOGOUT,
  VISITED_PAGE,
  VISITED_REPORTS,
  VISITED_SEARCH,
  VISITED_VERSION
} from 'app/Router/const';

import BasicBoundary from './BasicBoundary';
import CanvasApp from './CanvasApp';
import Logout from './Logout';
import Version from './Version';

/* eslint-disable no-inline-comments */
const ContractPreview = loadable(() =>
  import(/* webpackChunkName: "ContractPreview" */ 'app/ContractPreview/container')
);
const LocalCanvasPreview = loadable(() =>
  import(/* webpackChunkName: "LocalCanvasPreview" */ 'app/LocalCanvasPreview')
);
const Reports = loadable(() =>
  import(/* webpackChunkName: "Reports" */ 'app/Reports/container')
);

/**
 * handle routes and render the app
 */
export default class App extends Component {
  static propTypes = {
    applicationMode: propTypes.string.isRequired,
    pathType: propTypes.string.isRequired,
    payload: propTypes.shape({
      reportName: propTypes.string
    }).isRequired
  };

  /**
   * get view to render based on route
   * @returns {React.Component} the view to be rendered
   */
  renderView() {
    const {
      applicationMode,
      pathType,
      payload: { reportName }
    } = this.props;

    switch (pathType) {
      case VISITED_APP:
      case VISITED_COMPONENT:
      case VISITED_FOLDER:
      case VISITED_PAGE:
      case VISITED_SEARCH:
        return <CanvasApp applicationMode={applicationMode} />;
      case VISITED_CONTRACT:
        return <ContractPreview />;
      case VISITED_CANVAS:
        return <LocalCanvasPreview />;
      case VISITED_LOGOUT:
        return <Logout />;
      case VISITED_VERSION:
        return <Version />;
      case VISITED_REPORTS:
        return <Reports reportName={reportName} />;
      default:
        return <div data-test-id={`${pathType}-empty-view`} />;
    }
  }

  render() {
    return (
      <BasicBoundary>
        <Notifications />
        {this.renderView()}
      </BasicBoundary>
    );
  }
}
